<template>
  <div class="contents" v-loading="loading" element-loading-text="加载中">
    <HeaderNav :current="current" :titleMsg='titleMsg'></HeaderNav>
    <Banner></Banner>
    <Tabs></Tabs>
    <!-- <Notice></Notice>
    <MemberUnit></MemberUnit>
    <SignMember></SignMember> -->
    <Photos></Photos>
    <!-- <div class="blue-line"></div> -->
    <!-- <ContactUs></ContactUs> -->
    <CopyRight></CopyRight>
    <BackTop></BackTop>
  </div>
</template>
<script>
import BackTop from '@/components/common/BackTop/BackTop'
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import Banner from '@/components/common/Banner/Banner'
import Tabs from '@/components/common/Tabs/Tabs'
import Notice from '@/components/common/Notice/Notice'
import MemberUnit from '@/components/common/MemberUnit/MemberUnit'
import SignMember from '@/components/common/SignMember/SignMember'
import Photos from '@/components/common/Photos/Photos'
import ContactUs from '@/components/common/ContactUs/ContactUs'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import { findAssoAbout } from '@/api/association'
export default {
  name: 'Index',
  components: {
    HeaderNav,
    Banner,
    Tabs,
    Notice,
    MemberUnit,
    SignMember,
    Photos,
    ContactUs,
    CopyRight,
    BackTop
  },
  data () {
    return {
      current: 1,
      titleMsg: '首页',
      loading: false
    }
  },
  methods: {
    getAssoAbout () {
      findAssoAbout({ assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          localStorage.setItem('aboutInfo', JSON.stringify(res.data.data))
        }
      })
    }
  },
  mounted () {
  },
  created () {
    this.getAssoAbout()
  },
  beforeCreate () {
    localStorage.setItem('assoId', 1)

    // var host = window.location.host
    // var protocol = window.location.protocol
    // console.log(host, protocol)
    // findAssoIdByDomainName({ domainName: protocol + '//' + host }).then(res => {
    //   this.loading = false
    //   // debugger
    //   if (res.data.status === 0) {
    //     if (res.data.data == null) {
    //       this.$message.error('协会信息获取失败')
    //     } else {
    //       localStorage.setItem('assoId', res.data.data.id)
    //       // localStorage.setItem('assoInfo', JSON.stringify(res.data.data))
    //       this.getAssoAbout()
    //     }
    //   }
    // }).catch(() => {
    //   this.loading = false
    //   // this.$message.error('网络错误')
    // })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .blue-line {
    width: 100%;
    height: 54px;
    background: #3174c3;
  }

</style>



// WEBPACK FOOTER //
// src/components/Index.vue